export default "__VITE_ASSET__1Q4QH8up__"